import {
  getTransitionDuration
} from './utils.js'


const canadaSvg = document.querySelector('#svg-canada-map')

if (canadaSvg) {
  const provLinksList = document.querySelector('[data-provinces]')
  const provLinks = provLinksList.querySelectorAll('a')

  const provSvgContainer = document.querySelector('[data-highlighted]')
  const provSvgLinks = canadaSvg.querySelectorAll('a')

  const linkNodesMap = new Map()

  for (const linkEl of provLinks) {
    let linkMatch = [...provSvgLinks].filter(svgLink => svgLink.attributes.href.value === linkEl.attributes.href.value)
    let provGroup = linkMatch[0].getAttribute('aria-labelledby').replace('list-', '')

    linkNodesMap.set(provGroup, {
      "list": linkEl,
      "svg": linkMatch[0]
    })
  }

  let effectTimeout = undefined
  let effectDuration = getTransitionDuration(provSvgContainer, '::before')

  const getMatch = (eventLink) => {
    let provinceId = eventLink.id || eventLink.getAttribute('aria-labelledby')
    let nodes = linkNodesMap.get(provinceId.replace('list-', ''))
    let match = Object.values(nodes).filter(link => link !== eventLink)[0]
    return match
  }

  const highlightMatch = (event) => {
    let matchingLink = getMatch(event.target)
    let isSvgLink = !!event.target.closest('svg')

    matchingLink.dataset.match = 'true'

    if (isSvgLink) {
      if (typeof effectTimeout === 'number') {
        // Then there's an active timeout set by unhighlightMatch,
        // and it needs to get cleared to prevent the overlaid text
        // from disappearing despite the cursor/focus still being
        // in the svg map:
        clearTimeout(effectTimeout)
      }
      provSvgContainer.dataset.highlighted = matchingLink.innerText
    }
  }

  const unhighlightMatch = (event) => {
    let matchingLink = getMatch(event.target)
    let isSvgLink = !!event.target.closest('svg')

    matchingLink.dataset.match = 'false'

    if (isSvgLink) {
      // Give the overlaid text time to fade out:
      effectTimeout = setTimeout(() => {
        provSvgContainer.dataset.highlighted = ''
      }, effectDuration)
    }
  }



  for (const [id, links] of linkNodesMap) {
    links['list'].addEventListener('mouseenter', highlightMatch)
    links['list'].addEventListener('mouseleave', unhighlightMatch)
    links['list'].addEventListener('focus', highlightMatch)
    links['list'].addEventListener('focusout', unhighlightMatch)

    links['svg'].addEventListener('mouseenter', highlightMatch)
    links['svg'].addEventListener('mouseleave', unhighlightMatch)
    links['svg'].addEventListener('focus', highlightMatch)
    links['svg'].addEventListener('focusout', unhighlightMatch)
  }
}
